var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('campaigns-factory',{attrs:{"name":"Voter Outreach","adlabels":['OF-Primary', 'OF-General', 'OF-GOTV']}})}
var staticRenderFns = []

export { render, staticRenderFns }